export const TIMELINES = {
    MONTHLY: 'monthly',
    YEARLY: 'yearly'
}

export const TIMELINES_NOUNS = {
    [TIMELINES.MONTHLY]: 'miesiąc',
    [TIMELINES.YEARLY]: 'rok'
}

export const TIMELINES_ADJECTIVES = {
    [TIMELINES.MONTHLY]: 'miesięczny',
    [TIMELINES.YEARLY]: 'roczny'
}

export const TARIFF = {
    description_long: 'Pakiet obejmuje dostęp <strong>do aplikacji mobilnej</strong> (do 100 pracowników) oraz integrację <strong>z 1 stanowiskiem kasowym</strong>.',
    features: {
        list: [
            {
                label: 'Dostęp do aplikacji mobilnej dla 100 pracowników',
                tooltip: 'Aplikacja umożliwia zarządzanie opakowaniami w sklepie'
            },
            {
                label: 'Integrację z jednym stanowiskiem kasowym'
            }
        ]
    },
    optionals: {
        list: [
            { id: 1, code: 'ecr', name: 'Dodatkowe stanowisko kasowe (do 100 stanowisk na sklep)', description: '(do 100 stanowisk na sklep)', price: 0.99, maxQty: 100 },
            { id: 2, code: 'rvm', name: 'Kompatybilny automat RVM (do 10 butelkomatów na sklep)', description: '(do 10 butelkomatów na sklep)', price: 0.99, maxQty: 10 }
        ]
    }
}